<script lang="ts">
    import { getTypedContext } from "@lib/svelte-typed-context";
    import { onMount } from "svelte";
    import { fly } from "svelte/transition";

    import { stepperControllerContextToken } from "./context_tokens";
    import { ANIMATION_DIRECTION } from "./types";

    export let name: string;
    export let order: number;

    const stepperController = getTypedContext(stepperControllerContextToken);
    const currentStep$ = stepperController.currentStep$;

    onMount(() => {
        stepperController.registerStep(name, order);
        return () => stepperController.unregisterStep(name);
    });

    const inAnimation$ = stepperController.inAnimation$;
    const outAnimation$ = stepperController.outAnimation$;

    const xTransition = {
        [ANIMATION_DIRECTION.FROM_LEFT_TO_RIGHT]: 128,
        [ANIMATION_DIRECTION.FROM_RIGHT_TO_LEFT]: -128,
        [ANIMATION_DIRECTION.NO_ANIMATION]: 0,
    };
</script>

{#if name === $currentStep$?.name}
    <div
        class="gw-stepper__step-container"
        in:fly={{ x: xTransition[$inAnimation$], y: 0, duration: 500 }}
        out:fly={{ x: xTransition[$outAnimation$], y: 0, duration: 500 }}
    >
        <slot />
    </div>
{/if}

<style>
    .gw-stepper__step-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
